<div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h1 pr-16">Servicios</div>
    </div>

    <mat-form-field class="full-width">
        <span matPrefix>
            <mat-icon>search</mat-icon>
        </span>
        <input matInput #filter placeholder="Buscar..." />
    </mat-form-field>

    <div class="contenedor-tabla">
        <mat-table
            class="servicios-tabla"
            #table
            [dataSource]="dataSource"
            matSort
            [@animateStagger]="{ value: '50' }"
            fusePerfectScrollbar
        >
            <ng-container matColumnDef="descripcion">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Servicio</mat-header-cell
                >
                <mat-cell *matCellDef="let servicio">
                    <p>
                        <a
                            [routerLink]=""
                            (click)="verDetalleServicio(servicio)"
                        >
                            {{ servicio.descripcion }}
                            {{ servicio.atributos.join(", ") }}
                            <mat-icon *ngIf="servicio.conAdjunto"
                                >attach_file</mat-icon
                            >
                        </a>
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="estado">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Estado</mat-header-cell
                >
                <mat-cell *matCellDef="let servicio">
                    <span>
                        <strong
                            *ngIf="
                                servicio.valorUF &&
                                !servicio.idOrdenTrabajo &&
                                servicio.comentario === null
                            "
                            >Cotizado
                        </strong>
                        <strong
                            *ngIf="
                                !servicio.valorUF &&
                                servicio.comentario === null
                            "
                        >
                            Pendiente de cotización
                        </strong>
                        <strong
                            *ngIf="!servicio.aceptada && servicio.comentario"
                        >
                            Rechazada
                        </strong>
                        <strong
                            *ngIf="
                                servicio.valorUF &&
                                servicio.idOrdenTrabajo &&
                                servicio.aceptada
                            "
                        >
                            Solicitado
                        </strong>
                    </span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cliente">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Cliente</mat-header-cell
                >
                <mat-cell *matCellDef="let servicio">
                    <p>
                        {{ servicio.sucursal.cliente.nombre }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="sucursal">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Sucursal</mat-header-cell
                >
                <mat-cell *matCellDef="let servicio">
                    <p>
                        {{ servicio.sucursal.nombre }} -
                        {{ servicio.sucursal.direccion }},
                        {{ servicio.sucursal.comuna.nombre }}
                    </p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cantidad">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Cantidad</mat-header-cell
                >
                <mat-cell *matCellDef="let servicio">
                    <p *ngIf="servicio.cantidad">
                        {{ servicio.cantidad }}
                        {{ servicio.unidadMedida.descripcion }}
                    </p>

                    <span *ngIf="!servicio.cantidad">-</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="tiempo">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Tiempo</mat-header-cell
                >
                <mat-cell *matCellDef="let servicio">
                    <p *ngIf="servicio.tiempo">
                        {{ servicio.tiempo }}
                        {{ servicio.unidadTiempo.descripcion }}
                    </p>

                    <span *ngIf="!servicio.tiempo">-</span>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="valorUF">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    >Valor</mat-header-cell
                >
                <mat-cell *matCellDef="let servicio">
                    <p *ngIf="servicio.valorUF">
                        UF {{ servicio.valorUF }}
                        <br />
                        <small class="primary p-4">
                            {{
                                servicio.valorCLP
                                    | currency: "CLP":"symbol-narrow"
                            }}
                        </small>
                    </p>
                    <p *ngIf="!servicio.valorUF">-</p>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let servicio">
                    <p>
                        <button
                            *ngIf="
                                !servicio.idOrdenTrabajo &&
                                servicio.valorCLP &&
                                puedeComprar(servicio.sucursal.id) &&
                                servicio.aceptada === null &&
                                cotizacion.vigente
                            "
                            mat-button
                            type="button"
                            color="accent"
                            (click)="solicitar(servicio)"
                        >
                            Solicitar
                        </button>
                        <button
                            *ngIf="
                                !servicio.idOrdenTrabajo &&
                                servicio.valorCLP &&
                                puedeComprar(servicio.sucursal.id) &&
                                servicio.aceptada === null &&
                                cotizacion.vigente
                            "
                            mat-button
                            type="button"
                            color="accent"
                            (click)="rechazar(servicio)"
                        >
                            Rechazar
                        </button>
                        <button
                            *ngIf="
                                (!servicio.valorUF ||
                                    (servicio.valorUF &&
                                        !cotizacion.vigente)) &&
                                _menuUsuarioSrvc.esSupervisor()
                            "
                            mat-button
                            type="button"
                            color="accent"
                            (click)="cotizar(servicio)"
                        >
                            <span *ngIf="!servicio.valorUF"> Cotizar </span>
                            <span
                                *ngIf="
                                    servicio.valorUF && servicio.idOrdenTrabajo
                                "
                                >Aumento de obra</span
                            >
                            <span
                                *ngIf="
                                    servicio.valorUF &&
                                    !servicio.idOrdenTrabajo &&
                                    !cotizacion.vigente
                                "
                                >Actualizar cotización</span
                            >
                        </button>

                        <button
                            *ngIf="
                                servicio.grupoServicio.id === 0 &&
                                !servicio.valorUF &&
                                !servicio.idOrdenTrabajo &&
                                _menuUsuarioSrvc.esSupervisor()
                            "
                            mat-button
                            type="button"
                            color="accent"
                            (click)="invitarACotizar(servicio)"
                        >
                            Invitar a cotizar
                        </button>
                    </p>
                </mat-cell>
            </ng-container>

            <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></mat-header-row>

            <mat-row *matRowDef="let servicio; columns: displayedColumns">
            </mat-row>
        </mat-table>


        <mat-paginator
            #paginator
            [length]="dataSource?.filteredData?.length"
            [pageIndex]="0"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"
        >
        </mat-paginator>
    </div>

    <div
    fxLayout="row"
    fxLayoutAlign.lt-md="center center"
    fxLayoutAlign="end end"
    fxLayoutGap="10px"
>

<!-- 
    !cotizacion.vigente && !cotizacion.fechaVigencia
        ? "Enviar Cotización"
        : "Actualizar y Enviar Cotización"
-->

<div *ngIf="cotizacion">
        <!-- div *ngIf="cotizacion.valor && !cotizacion.vigente" -->
            <button
                *ngIf="_menuUsuarioSrvc.esEncargado()"
                [disabled]="procesando || (!cotizacion.valor || cotizacion.vigente)"
                mat-raised-button
                color="accent"
                class="mt-16"
                (click)="solicitarActualizacion(cotizacion.id)"
            >
                Solicitar actualización
            </button>
            <button
                *ngIf="_menuUsuarioSrvc.esSupervisor()"
                [disabled]="procesando || (!cotizacion.valor || cotizacion.vigente)"
                mat-raised-button
                color="accent"
                class="mt-16"
                (click)="actualizarVigencia(cotizacion.id)"
            >
                {{
                    !cotizacion.vigente && !cotizacion.fechaVigencia
                        ? "Enviar Cotización"
                        : "Actualizar y Enviar Cotización"
                }}
            </button>
        <!-- /div -->
</div>

</div>

</div>
